import Test from "./Test.svelte"
import Row from "./Row.svelte"
import Col from "./Col.svelte"
import Video from "./Video.svelte"

export const shortcodeComponents = {
    test: Test,
    row: Row,
    col: Col,
    video: Video,
}
